import styled, {css} from 'styled-components';
import { FONTS, COLORS, SIZE } from '@app/src/ui';
import { RadioInput } from '../RadioInput/RadioInput';

interface ListItem {
  showFirstItems?: number;
}

interface Item {
  activeSuggestion?: boolean;
}

interface Wrapper {
  borderColor?: string;
  isSuggestions?: boolean;
}

export const InputWrapper = styled.input`
  outline: none;
  margin: 0;
  font-size: 14px;
  color: ${COLORS.BLACK};
  border: none;
  font-family: ${FONTS.ROBOTO};
  position: absolute;
  padding: 10px 40px 10px 38px;
  z-index: 2;
  background: transparent;
  width: 100%;
  height: 100%;

  &::placeholder {
    color: ${COLORS.GRAY_PLACEHOLDER};
  }
`;

export const Content = styled.div`
  position: relative;
  color: red;
  width: 100%;
`;

export const Wrapper = styled.div`
  background: #fff;
  height: 48px;
  border-radius: 6px;
  position: relative;
  box-sizing: border-box;
  display: block;

  ${(props: Wrapper) => props.borderColor && `border: ${props.borderColor}`};

  ${(props: Wrapper) => props.isSuggestions && `
    border-bottom: 0;
    border-radius: 6px 6px 0 0;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
    border-color: ${COLORS.GRAY};
  `};
`;

export const IconWrapper = styled.span`
  position: absolute;
  left: 12px;
  height: 18px;
  z-index: 3;
  top: 50%;
  transform: translateY(-50%);
`;

export const IconClose = styled.span`
  position: absolute;
  right: 12px;
  cursor: pointer;
  z-index: 2;
  top: 50%;
  transform: translateY(-50%);
`;

export const List = styled.ul`
  font-family: ${FONTS.ROBOTO};
  font-weight: 400;
  line-height: 17px;
  background: #fff;
  box-sizing: border-box;
  width: 100%;
  padding: 0;
  list-style: none;
  overflow-y: scroll;
  max-height: 215px;
  z-index: 1;
  position: absolute;
  top: 48px;
  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;
  border-radius: 0 0 6px 6px;
  
  @media (min-width: ${SIZE.TABLET_LANDSCAPE  }) {
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
    
    ${(props: ListItem) => props.showFirstItems && css`
      max-height: ${props.showFirstItems * 44}px;
      border-width: 0 1px 1px 1px;
      border-style: solid;
      border-color: ${COLORS.GRAY};
    `};
  }
`;

export const ListModel = styled(List)`
  position: relative;
  top: 0;
`;

export const Item = styled.li`
  display: flex;
  align-items: center;
  outline: none;
  min-height: 44px;
  cursor: pointer;
  :hover {
    background: aliceblue;
    color: ${COLORS.BLACK};
  }
  &:focus {
    background: aliceblue;
    color: ${COLORS.BLACK};
  }
  ${(props: Item) =>
    props.activeSuggestion &&
    css`
      background: aliceblue;
      color: ${COLORS.BLACK};
    `};
  p {
    font-size: 14px;
    color: ${COLORS.GRAY_DARK};
  }
  span {
    font-size: 16px;
    color: ${COLORS.BLACK};
  }
`;

export const Description = styled.div`
  padding: 0 12px;
`;

const TextPredictive = `
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  padding-right: 20px;
  font-family: ${FONTS.ROBOTO};
  color: ${COLORS.GRAY_DARK};
  font-size: 14px;
  position: absolute;
  span {
    font-size: 16px;
    pointer-events: none;
  }
`;

export const Placeholder = styled.p`
  ${TextPredictive};
  padding: 10px 40px 10px 38px;
  line-height: 30px;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  opacity: .7;
`;

export const Ubigeo = styled.p`
  ${TextPredictive};
  left: 38px;
  width: calc(100% - 50px);
  z-index: 1;
  top: 50%;
  transform: translateY(-50%);
  span {
    color: ${COLORS.BLACK};
  }
`;

export const ContentModal = styled.div`
  width: 280px;
  min-height: 80px;
  >div {
    border-radius: 6px 6px 0 0;
    border-bottom: 1px solid ${COLORS.GRAY_LIGHT};
  }
`;

export const ListOptionModal = styled.ul`
  background: #fff;
  border-radius: 3px;
  width: 280px;
  & li:nth-child(2) {
    display: none;
  }
`;

export const ModalTitle = styled.h3`
  font-family: ${FONTS.ROBOTO};
  font-weight: 600;
  font-size: 14px;
  padding: 0 15px;
  line-height: 44px;
`;

export const RadioInputWrapper = styled(RadioInput)`
  display: flex;
  width: 100%;
  padding: 0 12px;
  min-height: 44px;
  justify-content: space-between;
  :hover {
    background: aliceblue;
    color: ${COLORS.BLACK};
  }
  &:focus {
    background: aliceblue;
    color: ${COLORS.BLACK};
  }
  ${(props: Item) =>
    props.activeSuggestion &&
    css`
      background: aliceblue;
      color: ${COLORS.BLACK};
    `};
  p {
    font-size: 14px;
    color: ${COLORS.GRAY_DARK};
  }
  span {
    font-size: 16px;
    color: ${COLORS.BLACK};
  }
`;

export const ErrorMessage = styled.span`
  color: red;
  font-size: 11px;
`;

export const LoaderWrapper = styled.span`
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
  svg{
    fill: transparent;
    stroke-width: 5px;
    stroke: #b7b0b0;
    stroke-dasharray: 100%;
    animation: rotate .5s linear infinite;
  }
  @keyframes rotate {
    to {
      transform: rotate(360deg);
    }
  }
`

export const NotResults = styled.p`
  padding: 15px;
`;